<template>
  <div class="modal fade" id="myModal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <form>
          <label class="radio-inline">
            <input
              type="radio"
              name="optradio"
              checked
              value="儲值紀錄"
              v-model="isStored"
              @change="changData"
            />
            儲值紀錄
          </label>
          <label class="radio-inline">
            <input
              type="radio"
              name="optradio"
              value="扣款紀錄"
              v-model="isStored"
              @change="changData"
            />
            扣款紀錄
          </label>
        </form>
        <div class="table-box">
          <table
            class="table-item"
            v-if="data.length && this.isStored == '儲值紀錄'"
          >
            <thead>
              <th>日期</th>
              <th>呼號/姓名</th>
              <th>儲值/退款金額</th>
              <th>經手人</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in data" :key="index">
                <td>{{ transferDate(item.date) }}</td>
                <td>{{ item.driverCallNumber }} / {{ item.driverName }}</td>
                <td v-if="item.storedValueType == 0">
                  -${{ item.storedValueAmount }}(剩餘${{
                    item.storedValueBalance
                  }})
                </td>
                <td v-else>
                  ${{ item.storedValueAmount }}(剩餘${{
                    item.storedValueBalance
                  }})
                </td>
                <td>{{ item.teamManagerName }}</td>
              </tr>
            </tbody>
            <paginate
              :page-count="paging.totalPages"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :click-handler="clickCallback"
              :container-class="'pagination'"
              :key="key"
            ></paginate>
          </table>
          <table
            class="table-item"
            v-if="data.length && this.isStored == '扣款紀錄'"
          >
            <thead>
              <th>日期</th>
              <th>種類</th>
              <th>派車單號</th>
              <th>呼號/姓名</th>
              <th>車資</th>
              <th>扣款金額</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in data" :key="index">
                <td>{{ transferDate(item.date) }}</td>
                <td>{{ item.orderType ? '預約單' : '一般單' }}</td>
                <td>{{ item.orderId }}</td>
                <td>{{ item.driverCallNumber }} / {{ item.driverName }}</td>
                <td>${{ item.actualPrice }}</td>
                <td>
                  ${{ item.storedValueDeductAmount }}(剩餘${{
                    item.storedValueDeductBalance
                  }})
                </td>
              </tr>
            </tbody>
            <paginate
              :page-count="paging.totalPages"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :click-handler="clickCallback"
              :container-class="'pagination'"
              :key="key"
            ></paginate>
          </table>
          <h3 v-if="!data.length">暫時沒有紀錄</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/assets/js/libs/API'
import moment from 'moment'
import Paginate from 'vuejs-paginate'

export default {
  props: ['data', 'paging', 'status'],
  data() {
    return {
      count: 25,
      key: 0,
      isStored: '儲值紀錄',
    }
  },
  components: {
    Paginate,
  },
  methods: {
    transferDate(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    clickCallback(num) {
      this.$emit('changerecord', num, this.isStored)
    },
    changData() {
      this.key += 1
      this.$emit('changerecord', 1, this.isStored)
    },
  },
}
</script>

<style scoped lang="scss">
.table-item {
  margin: 15px;
  display: inline-block;
  border-radius: 5px;
  font-size: 16px;
  color: black;
  th {
    background-color: #405367;
    border: 1px solid black;
    color: white;
    padding: 20px 15px;
  }
  td {
    border: 1px solid black;
    padding: 20px 15px;
  }
  tr {
    background-color: white;
  }
  tr:nth-child(odd) {
    background-color: #f9f9f9;
  }
}
h3 {
  margin: 50px 0 50px 15px;
  color: red;
}
form {
  margin: 25px 15px 15px 15px;
  label {
    font-size: 18px;
  }
  input {
    margin-top: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/driver/DriverStoredModal.vue